import { API } from '@/api';

export const classes = {
  wrapper: 'place-start gap-2 cursor-pointer select-none',
  label: 'text-sm font-semibold text-white whitespace-nowrap',
};

export function logout() {
  return API.Users.logout();
}
